import { createDynamicFeatureSelector } from '@app/app.selectors';
import { BuyerQuestionnaireStoreState } from '@core/features/buyer-questionnaire/models/buyer-questionnaire-store.model';
import {
  buyerQuestionnaireReducerKey,
  initialBuyerQuestionnaireStoreState
} from '@core/features/buyer-questionnaire/store/buyer-questionnaire.reducer';
import { createSelector } from '@ngrx/store';

const buyerQuestionnaireFeatureSelector = createDynamicFeatureSelector<BuyerQuestionnaireStoreState>(
  buyerQuestionnaireReducerKey,
  initialBuyerQuestionnaireStoreState
);

export const selectBuyerQuestionnaireDynamicFields = createSelector(
  buyerQuestionnaireFeatureSelector,
  ({ dynamicFields }) => dynamicFields.buyerQuestionnaire
);

export const selectBuyerQuestionnaireForm = createSelector(
  buyerQuestionnaireFeatureSelector,
  ({ forms }) => forms.buyerQuestionnaire
);

export const selectBuyerQuestionnaireFormFields = createSelector(
  selectBuyerQuestionnaireForm,
  ({ formFields }) => formFields
);
